"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9815],{

/***/ 66565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CheckboxSVG = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.55491 13.1098C10.1751 13.1098 13.1098 10.1751 13.1098 6.55491C13.1098 2.93474 10.1751 0 6.55491 0C2.93474 0 0 2.93474 0 6.55491C0 10.1751 2.93474 13.1098 6.55491 13.1098ZM9.86117 5.0764C10.0949 4.76985 10.0358 4.33187 9.72927 4.09817C9.42271 3.86446 8.98474 3.92352 8.75103 4.23008L6.16635 7.62044L4.90602 6.10805C4.65924 5.81192 4.21912 5.7719 3.92299 6.01868C3.62685 6.26546 3.58684 6.70558 3.83362 7.00172L6.21491 9.85927L9.86117 5.0764Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxSVG);


/***/ }),

/***/ 61740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sign_up; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts.js + 3 modules
var consts = __webpack_require__(78679);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.scss.js

var StyledProductSignUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef6wzw60"
})("display:flex;flex-direction:row;height:50px;.product-logo-image{display:flex;align-items:center;.picture-component{img{width:160px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js















var _obj;
var PRODUCT_TYPE_TO_IMAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png"), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"), _obj);
var ProductSignUp = function(param) {
    var displayImage = param.displayImage, useCtaText = param.useCtaText, buttonSize = param.buttonSize, withButtonArrow = param.withButtonArrow, ctaText = param.ctaText, _productType = param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, _selectedProductIds = param.selectedProductIds, selectedProductIds = _selectedProductIds === void 0 ? [] : _selectedProductIds, signupClusterId = param.signupClusterId, useCtaIcon = param.useCtaIcon, _buttonColor = param.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.WHITE_COLOR_NAME : _buttonColor, invert = param.invert, beforeSubmitCallback = param.beforeSubmitCallback, excludeFromWMHighIntentExperienceTest = param.excludeFromWMHighIntentExperienceTest;
    var getProductsCookiesKey = function() {
        if (selectedProductIds.length === 1) {
            return selectedProductIds[0];
        }
        if (selectedProductIds.length === 2) {
            var sortedIds = selectedProductIds.sort();
            return "".concat(sortedIds[0], "_").concat(sortedIds[1]);
        }
        return null;
    };
    var updateClusters = function() {
        var res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach(function(id) {
                var clusterId = consts/* procuctIdToCluster */.Oh[id];
                if (clusterId) res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            });
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(res, clusters.HP_TAGS_SELECTION);
        }
    };
    var addTestCookiesAndClusters = function(cookieKey) {
        (0,cookies_service/* setCookie */.d8)(cookies.SKIP_AB_TESTS_HP, true, {
            expires: 1 // 1 day
        });
        (0,cookies_service/* setCookie */.d8)(cookies.MULTIPLE_PRODUCTS_SELECTION, true, {
            expires: 1 // 1 day
        });
        var productsKey = cookieKey || getProductsCookiesKey();
        if (productsKey) {
            var cookieArray = consts/* cookieValues */.$s[productsKey];
            cookieArray === null || cookieArray === void 0 ? void 0 : cookieArray.forEach(function(cookie) {
                (0,cookies_service/* setCookie */.d8)(cookie.key, cookie.value, {
                    expires: 1 // 1 day
                });
            });
        } else {
            (0,cookies_service/* setCookie */.d8)(cookies.INSTALL_PRODUCTS_FLOW, false, {
                expires: 1 // 1 day
            });
        }
        updateClusters();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, {
                isWMHighIntentExperience: productType === products/* WORK_MANAGEMENT_PRODUCT_ID */.py,
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize !== null && buttonSize !== void 0 ? buttonSize : sizes.SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: function() {
                    addTestCookiesAndClusters(productType);
                    beforeSubmitCallback && beforeSubmitCallback();
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: {
                    selectedProduct: productType
                },
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            })
        ]
    });
};
/* harmony default export */ var product_sign_up = (ProductSignUp);
ProductSignUp.defaultProps = default_props;


/***/ }),

/***/ 32622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ selectable_tag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./static/svg/check.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCheck = function SvgCheck(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 7,
        viewBox: "0 0 10 7"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        d: "M1.22 3.005a.725.725 0 0 0-1.01 0 .69.69 0 0 0 0 .99l2.856 2.8a.725.725 0 0 0 1.01 0l5.715-5.6a.69.69 0 0 0 0-.99.725.725 0 0 0-1.01 0L3.57 5.31z"
    })));
};
/* harmony default export */ var check = (SvgCheck);

// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag-constants.js
var MAIN_CLASSNAME = "selectable-tag-wrapper"; // used in the scss file but can't inject it so mind if changing

;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/default-props.js
/* harmony default export */ var default_props = ({
    tagText: "Project Management",
    isSelected: false,
    tagBackgroundColor: "auto",
    tagValue: null,
    overridePageCluster: null,
    overridePageSubCluster: null,
    galleryImage: null
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag.scss.js




var tagSelectedBackgroundColor = "#dff0ff";
var tagSelectedBackgroundColorDarkMode = "#49497D";
var VISIBLE_CHECKMARK_STYLE = "\n      background-color: currentColor;\n      box-shadow: inset 0px 0px 0px 1.5px currentColor;\n      border: none;\n";
var StyledSelectableTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ej25d0q0"
})("padding:4px 16px 4px 4px;border-radius:80px;display:flex;flex-direction:row;justify-content:center;align-items:center;cursor:pointer;margin:6px 12px 6px 0;background:", colors/* default.riverstone */.Z.riverstone, ";&.dark-mode{background:", colors/* default.midnightblue */.Z.midnightblue, ";&.selected{background-color:", tagSelectedBackgroundColorDarkMode, ";&:hover{background-color:", tagSelectedBackgroundColorDarkMode, ";}}&.square .selectable-tag-image-container{background:", colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME], ";}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.mobile-clusters{margin-right:6px;background:white;padding:4px 12px 5px 4px;&:hover{background:white;}.tag-text{font-size:0.844rem;}}}&.square{padding:8px 16px 8px 12px;.selectable-tag-image-container{border-radius:2px;width:18px;height:18px;background-color:", colors/* default.white */.Z.white, ";box-shadow:none;border:1px solid currentColor;}.tag-text{font-size:0.875rem;}&.selected{.selectable-tag-image-container{", VISIBLE_CHECKMARK_STYLE, "}}}&:hover{background:", colors/* default.border-gray */.Z["border-gray"], ";outline:0;&.dark-mode{background:", colors/* default.midnightblue-hover */.Z["midnightblue-hover"], ";}}.selectable-tag-image-container{width:32px;height:32px;border-radius:50%;display:flex;justify-content:center;align-items:center;user-select:none;.selectable-tag-image{display:flex;justify-content:center;align-items:center;height:100%;img{width:16px;height:16px;}}}.tag-text{margin-left:8px;font-size:0.8125rem;line-height:22px;}&.selected{background-color:", tagSelectedBackgroundColor, ";&:hover{background-color:", tagSelectedBackgroundColor, ";}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag.js











var SelectableTag = function(props) {
    var tagText = props.tagText, showMobileClusterTags = props.showMobileClusterTags, darkMode = props.darkMode, onHover = props.onHover, value = props.value, galleryImage = props.galleryImage, tagBackgroundColor = props.tagBackgroundColor, overridePageCluster = props.overridePageCluster, isSelected = props.isSelected, defaultFillColor = props.defaultFillColor;
    var ref = (0,react.useState)(false), isSelectedState = ref[0], setIsSelected = ref[1];
    (0,react.useEffect)(function() {
        setIsSelected(isSelected);
    }, [
        isSelected
    ]);
    var blurTag = function(e) {
        var _e_target_closest, _e_target;
        e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".".concat(MAIN_CLASSNAME))) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
    };
    var onMouseOver = function() {
        var tag = {
            isSelectedState: isSelectedState,
            tagText: tagText,
            value: value,
            galleryImage: galleryImage
        };
        onHover && onHover(tag);
    };
    var onClick = function(e) {
        blurTag(e);
        toggleTagSelection();
    };
    var toggleTagSelection = function() {
        var nextSelectedState = !isSelectedState;
        setIsSelected(nextSelectedState);
        props.onClick && props.onClick(nextSelectedState);
        BigBrain("track", bigbrain_event_types.SELECTED_TAG_EVENT, {
            kind: nextSelectedState,
            info1: tagText,
            info2: tagBackgroundColor
        });
    };
    var getTagContainerStyle = function() {
        if (showMobileClusterTags) {
            return {
                border: "1px solid ".concat(colors/* default */.Z[tagBackgroundColor])
            };
        }
        return {};
    };
    var getTagImageContainerStyle = function() {
        return {
            color: colors/* default */.Z[tagBackgroundColor]
        };
    };
    var getCheckIconImageStyle = function() {
        if (defaultFillColor) {
            return {
                fill: defaultFillColor
            };
        }
        var fill = darkMode ? colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME] : colors/* default.white */.Z.white;
        return {
            fill: fill
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableTag, {
        role: "button",
        className: classnames_default()(MAIN_CLASSNAME, {
            selected: isSelectedState,
            "dark-mode": darkMode,
            square: !showMobileClusterTags,
            "mobile-clusters": showMobileClusterTags
        }),
        style: getTagContainerStyle(),
        onClick: onClick,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(toggleTagSelection),
        tabIndex: 0,
        onMouseEnter: onMouseOver,
        onFocus: onMouseOver,
        children: [
            !showMobileClusterTags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "selectable-tag-image-container",
                style: getTagImageContainerStyle(),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(check, {
                    className: "selectable-tag-image",
                    style: getCheckIconImageStyle()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tag-text",
                children: tagText
            })
        ]
    });
};
SelectableTag.defaultProps = default_props;
/* harmony default export */ var selectable_tag = (SelectableTag);


/***/ }),

/***/ 69815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ carousel_selectable_product_cards_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/consts.js
var CAROUSEL_PROPS = {
    dots: false,
    centerMode: false,
    infinite: true,
    slidesToScroll: 2,
    draggable: false,
    easing: "ease-in-out",
    arrows: true,
    focusOnSelect: false,
    showFocusEffect: false
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var constants_clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/clusters-signup/clusters-signup.scss.js




var StyledClustersSignup = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eki77320"
})("display:flex;align-items:center;width:100%;justify-content:center;&.cluster-selected{animation:breatheOut 0.3s linear;}.signup-button-wrapper{transform:scale(1);button.signup-button{background-image:", function(param) {
    var background = param.background;
    return background;
}, ";color:", function(param) {
    var textColor = param.textColor;
    return textColor;
}, ";&:disabled{background-image:", function(param) {
    var background = param.background;
    return background;
}, ";color:", function(param) {
    var textColor = param.textColor;
    return textColor;
}, ";}}.sign-up-combo-with-text-underline{.sign-up-combo-wrapper{.signup-combo-buttons-button{justify-content:center;.secondary-button-wrapper{.secondary-button{.with-underline{background:unset;.secondary-button-text{padding-left:8px;}}}&:hover{.secondary-button{.with-underline{.secondary-button-text{transition:color 0.15 ease-in-out;color:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}svg path{transition:fill 0.15 ease-in-out;fill:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}}}}}}}.text-wrapper{margin-top:32px;font-size:0.8125rem;text-align:center;padding-left:3px;}}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js + 2 modules
var product_sign_up = __webpack_require__(61740);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/clusters-signup/clusters-signup.js















var LIGHT_THEME_BUTTON_OPACITY = "ee";
var ClustersSignup = function(param) {
    var _clusters = param.clusters, clusters = _clusters === void 0 ? [] : _clusters, wasClusterSelected = param.wasClusterSelected, _buttonConfig = param.buttonConfig, buttonConfig = _buttonConfig === void 0 ? {} : _buttonConfig, selectedProducts = param.selectedProducts;
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var productType = (0,react.useMemo)(function() {
        return (selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.length) === 1 ? selectedProducts[0] : products/* WORK_MANAGEMENT_PRODUCT_ID */.py;
    }, [
        selectedProducts
    ]);
    var getButtonTextColor = function() {
        var buttonColor = buttonConfig.buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) {
            return buttonColor === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        }
        if (buttonColor === color_consts.WHITE_COLOR_NAME && clusters.length === 0) {
            return colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
        }
        return colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
    };
    var getButtonColorBySelectedClusters = function() {
        var buttonColor = buttonConfig.buttonColor, removeGradient = buttonConfig.removeGradient;
        if (removeGradient) return colors/* default */.Z[buttonColor];
        if ((clusters === null || clusters === void 0 ? void 0 : clusters.length) === 0) {
            return isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]) : colors/* default */.Z[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (clusters.length === 1) {
            var colorName = clusters[0].tagBackgroundColor;
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[colorName]) : colors/* default */.Z[colorName];
            return "linear-gradient(90deg, ".concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " 0%, ").concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " 100%)");
        }
        var colorsString = "";
        var chunkSize = 100 / (clusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        clusters === null || clusters === void 0 ? void 0 : clusters.forEach(function(param, index) {
            var tagBackgroundColor = param.tagBackgroundColor;
            // add separator in every chunk instead of last chunk
            var separator = index === clusters.length - 1 ? "" : ", ";
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[tagBackgroundColor]) : colors/* default */.Z[tagBackgroundColor];
            colorsString += "".concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " ").concat(chunkSize * index, "%").concat(separator);
        });
        return "linear-gradient(90deg, ".concat(colorsString, ")");
    };
    var saveClustersOnSignup = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_WITH_TAGS, {
            info1: clusters.map(function(tag) {
                return tag.tagText;
            })
        });
        var clustersToUpdate = clusters === null || clusters === void 0 ? void 0 : clusters.map(function(tag) {
            var clusterId = tag.overridePageCluster;
            var useCaseId = tag.overridePageSubCluster;
            var res = [];
            clusterId && res.push({
                clusterId: clusterId,
                clusterType: types.CLUSTER_TYPE
            });
            if (useCaseId) {
                var extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            (0,hotjar_service/* fireHotjarEvents */.no)(flattenedArray.map(function(cluster) {
                return "tag_selected_".concat(cluster.clusterType, "_").concat(cluster.clusterId);
            }));
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, constants_clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClustersSignup, {
        background: getButtonColorBySelectedClusters(),
        textColor: getButtonTextColor(),
        className: classnames_default()("clusters-signup", {
            "cluster-selected": wasClusterSelected
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onMouseEnter: function() {
                return setIsHover(true);
            },
            onMouseLeave: function() {
                return setIsHover(false);
            },
            className: "cta-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_sign_up/* default */.Z, {
                buttonSize: "",
                buttonColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                productType: productType,
                skipUpdateCluster: false,
                beforeSubmitCallback: saveClustersOnSignup
            })
        })
    });
};
/* harmony default export */ var clusters_signup = (ClustersSignup);

// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-component.scss.js


var StyledCarouselSelectableProductCardsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e18d1nn10"
})("&.cluster-selected{animation:breatheOut 0.3s linear;}.carousel{.slick-slider .slick-list .slick-track{padding-top:0;}&:not(:hover){.carousel-arrow-wrapper.slick-arrow{opacity:", function(param) {
    var isAutoPlay = param.isAutoPlay;
    return isAutoPlay ? 0 : 1;
}, ";}}&.slick-active{.carousel-arrow-wrapper{border-color:transparent;}}.carousel-arrow-wrapper.slick-arrow{opacity:1;transition:opacity 0.5s ease-in-out;height:fit-content;width:fit-content;z-index:", z_index/* TOP_LAYER */.nA, ";&:focus{outline:none;}&.next{right:20px;}&.prev{left:20px;}}}.clusters-signup{margin-top:48px;}");

// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-card/checkbox-icon.js
var checkbox_icon = __webpack_require__(66565);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tag/selectable-tag.js + 4 modules
var selectable_tag = __webpack_require__(32622);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/selectable-product-card/selectable-product-card.scss.js





var CARD_BACKGROUND_COLOR = "#343751";
var StyledSelectableProductCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1xxl9vc0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;cursor:pointer;width:412px;height:fit-content;background-color:", CARD_BACKGROUND_COLOR, ";margin:0 20px;border-radius:12px;position:relative;overflow:hidden;&.card-animation{animation:breatheOut 0.3s linear;}.card-tag{.selectable-tag-wrapper{z-index:", z_index/* TOP_LAYER */.nA, ";background-color:", colors/* default */.Z[color_consts.RACKLEY_BLUE], ";padding:12px 16px;border-radius:90px;position:absolute;top:16px;left:16px;&.dark-mode:hover{background-color:", colors/* default */.Z[color_consts.RACKLEY_BLUE], ";opacity:0.85;}.selectable-tag-image-container{border-radius:4px;}&:not(.selected){.selectable-tag-image-container{background-color:transparent;border-color:white;.selectable-tag-image{display:none;}}}.tag-text{color:white;font-size:1rem;", function(param) {
    var isSelectable = param.isSelectable;
    return !isSelectable && "margin-left: 0;";
}, "}}}.picture-wrapper{display:flex;justify-content:center;padding:4px;.picture-component{display:flex;img{border-radius:8px;width:100%;}}}.card-content{position:absolute;bottom:-60%;width:100%;padding:20px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;background-color:", CARD_BACKGROUND_COLOR, ";.title-wrapper{margin:20px 0 20px 20px;}.use-cases-wrapper{display:flex;flex-wrap:wrap;gap:12px;padding:20px 0;.use-case{display:flex;gap:4px;align-items:center;font-size:0.875rem;color:", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR_NAME], ";}}.product-logo-wrapper{.picture-component{display:flex;img{height:32px;}}}.product-signup-wrapper{display:flex;}&.up{animation:slide-up 0.75s ease-in-out forwards;}&.down{animation:slide-down 0.75s ease-in-out forwards;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){margin:0 8px;width:370px;.card-content{.title-wrapper{margin:12px 0 12px 20px;}.use-cases-wrapper{.use-case{font-size:0.75rem;}}}}@keyframes slide-up{0%{bottom:-60%;}100%{bottom:0;}}@keyframes slide-down{0%{bottom:0;}100%{bottom:-60%;}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/selectable-product-card/consts.js



var _obj;
var PRODUCT_ID_TO_LOGO = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/wm-logo.png"), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/crm-logo.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/teams-%20firstfold/dev-logo.png"), _obj);
var _obj1;
var PRODUCT_ID_TO_COLOR = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.WORK_OS_IRIS_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARKER_TINT_02_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), _obj1);
var _obj2;
var BUTTON_CONFIG_BY_PRODUCT = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, {
    signupProductId: products/* WORK_MANAGEMENT_PRODUCT_ID */.py
}), (0,_define_property/* default */.Z)(_obj2, products/* CRM_PRODUCT_ID */.$, {
    signupProductId: products/* CRM_PRODUCT_ID */.$
}), (0,_define_property/* default */.Z)(_obj2, products/* DEV_PRODUCT_ID */.xi, {
    signupProductId: products/* DEV_PRODUCT_ID */.xi
}), _obj2);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/selectable-product-card/selectable-product-card.js
function selectable_product_card_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_product_card_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}














var SelectableProductCard = function(param) {
    var cardAsset = param.cardAsset, onClick = param.onClick, useCases = param.useCases, productType = param.productType, tag = param.tag, selectableTags = param.selectableTags;
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var ref1 = (0,react.useState)(false), isHoverTransition = ref1[0], setIsHoverTransition = ref1[1];
    var ref2 = (0,react.useState)(false), isTagSelected = ref2[0], setIsTagSelected = ref2[1];
    var cardRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), tagAnimationActivated = ref3[0], setTagAnimationActivated = ref3[1];
    var handleMouseEnter = function() {
        setIsHovered(true);
        setIsHoverTransition(false);
    };
    var handleMouseLeave = function() {
        if (isHovered) setIsHoverTransition(true);
        setIsHovered(false);
    };
    var onCardClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_PRODUCT_TAG_CLICKED, {
            kind: tag.tagText
        });
        if (!selectableTags) return;
        setIsTagSelected(function(isSelected) {
            return !isSelected;
        });
        onClick && onClick();
        cardRef === null || cardRef === void 0 ? void 0 : cardRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        setTagAnimationActivated(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectableProductCard, {
        ref: cardRef,
        isSelectable: selectableTags,
        onAnimationEnd: function() {
            return setTagAnimationActivated(false);
        },
        onClick: onCardClick,
        className: classnames_default()("carousel-product-card", {
            "card-animation": tagAnimationActivated
        }),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            (tag === null || tag === void 0 ? void 0 : tag.tagText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "card-tag",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_tag/* default */.Z, {
                    defaultFillColor: colors/* default */.Z[color_consts.RACKLEY_BLUE],
                    tagText: tag.tagText,
                    isSelected: isTagSelected,
                    tagBackgroundColor: selectableTags ? color_consts.WHITE_COLOR_NAME : "transparent",
                    showMobileClusterTags: !selectableTags,
                    darkMode: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("card-content", {
                    up: isHovered,
                    down: isHoverTransition
                }),
                children: [
                    productType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-logo-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: PRODUCT_ID_TO_LOGO[productType]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(function(param) {
                            var useCase = param.useCase;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_icon/* default */.Z, {}),
                                    useCase
                                ]
                            }, useCase);
                        })
                    }),
                    !selectableTags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-signup-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({
                            buttonSize: button_component.XS,
                            extraData: {
                                tag: tag === null || tag === void 0 ? void 0 : tag.tagText,
                                productType: productType
                            }
                        }, BUTTON_CONFIG_BY_PRODUCT[productType]), {
                            buttonColor: PRODUCT_ID_TO_COLOR[productType],
                            withButtonArrow: false
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var selectable_product_card = (SelectableProductCard);

// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousle-arrows/prev-arrow.js

var PrevArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "31",
                cy: "31",
                r: "30.5",
                fill: "#181B34",
                stroke: "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2929 30.2929C17.9024 30.6834 17.9024 31.3166 18.2929 31.7071L24.6569 38.0711C25.0474 38.4616 25.6805 38.4616 26.0711 38.0711C26.4616 37.6805 26.4616 37.0474 26.0711 36.6569L20.4142 31L26.0711 25.3431C26.4616 24.9526 26.4616 24.3195 26.0711 23.9289C25.6805 23.5384 25.0474 23.5384 24.6569 23.9289L18.2929 30.2929ZM43 30L19 30V32H43V30Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var prev_arrow = (PrevArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousle-arrows/prev-carousel-arrow.js






var PrevCarouselArrow = function(param) {
    var className = param.className, onClick = param.onClick, pause = param.pause;
    var onPrevArrowClick = function() {
        if (onClick) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                info1: "product-cards",
                info3: "prev"
            });
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classnames_default()(className, "carousel-arrow-wrapper", "prev"),
        onClick: onPrevArrowClick,
        onMouseEnter: pause,
        tabIndex: 0,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prev_arrow, {})
    });
};
/* harmony default export */ var prev_carousel_arrow = (PrevCarouselArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousle-arrows/next-arrow.js

var NextArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "31",
                cy: "31",
                r: "30.5",
                transform: "matrix(-1 0 0 1 62 0)",
                fill: "#181B34",
                stroke: "#676879"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M43.7071 30.2929C44.0976 30.6834 44.0976 31.3166 43.7071 31.7071L37.3431 38.0711C36.9526 38.4616 36.3195 38.4616 35.9289 38.0711C35.5384 37.6805 35.5384 37.0474 35.9289 36.6569L41.5858 31L35.9289 25.3431C35.5384 24.9526 35.5384 24.3195 35.9289 23.9289C36.3195 23.5384 36.9526 23.5384 37.3431 23.9289L43.7071 30.2929ZM19 30L43 30V32H19V30Z",
                fill: "white"
            })
        ]
    });
};
/* harmony default export */ var next_arrow = (NextArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousle-arrows/next-carousel-arrow.js






var NextCarouselArrow = function(param) {
    var className = param.className, onClick = param.onClick, pause = param.pause;
    var onNextArrowClick = function() {
        if (onClick) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                info1: "product-cards",
                info3: "next"
            });
            onClick();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: classnames_default()(className, "carousel-arrow-wrapper", "next"),
        onClick: onNextArrowClick,
        tabIndex: 0,
        onMouseEnter: pause,
        onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_arrow, {})
    });
};
/* harmony default export */ var next_carousel_arrow = (NextCarouselArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/default-props.js
/* harmony default export */ var default_props = ({
    theme: "Black",
    cards: [
        {
            useCases: [
                {
                    useCase: "Social media planner"
                },
                {
                    useCase: "Marketing strategy"
                },
                {
                    useCase: "Content calendar"
                },
                {
                    useCase: "Campaign planning"
                }
            ],
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Creative.png",
            tag: {
                tagText: "Creative & Design",
                tagBackgroundColor: "Brand & WM Primary Color",
                overridePageCluster: "marketing"
            },
            productType: "work-management"
        },
        {
            useCases: [
                {
                    useCase: "Project management"
                },
                {
                    useCase: "Task management"
                },
                {
                    useCase: "Resource management"
                },
                {
                    useCase: "Portfolio management"
                }
            ],
            tag: {
                tagText: "Sales & CRM",
                overridePageCluster: "crm",
                tagBackgroundColor: "Marketer Lighter Tint 01"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/CRM.png"
        },
        {
            useCases: [
                {
                    useCase: "Design tasks"
                },
                {
                    useCase: "Digital Asset Management "
                },
                {
                    useCase: "Creative requests"
                },
                {
                    useCase: "Client campaigns "
                }
            ],
            tag: {
                tagText: "HR",
                tagBackgroundColor: "brand-green-dark-tint-01"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/HR.png"
        },
        {
            useCases: [
                {
                    useCase: "Sales pipeline"
                },
                {
                    useCase: "Lead management"
                },
                {
                    useCase: "Mass email & tracking"
                },
                {
                    useCase: "Contact management"
                }
            ],
            tag: {
                tagText: "Projects & Tasks",
                tagBackgroundColor: "CRM Primary color",
                overridePageCluster: "product_management"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Projects.png"
        },
        {
            useCases: [
                {
                    useCase: "IT service desk"
                },
                {
                    useCase: "Incident management"
                },
                {
                    useCase: "Inventory management "
                },
                {
                    useCase: "SLA tracking"
                }
            ],
            tag: {
                tagText: "Product & Dev",
                tagBackgroundColor: "Projects Primary Color"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Dev.png"
        },
        {
            useCases: [
                {
                    useCase: "Event management "
                },
                {
                    useCase: "Facilities requests"
                },
                {
                    useCase: "Finance requests "
                },
                {
                    useCase: "Order management "
                }
            ],
            tag: {
                tagText: "Marketing",
                tagBackgroundColor: "Projects Lighter Tint 01",
                overridePageCluster: "marketing"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/Marketing.png"
        },
        {
            useCases: [
                {
                    useCase: "Roadmap planning"
                },
                {
                    useCase: "Sprint management "
                },
                {
                    useCase: "Feature backlog "
                },
                {
                    useCase: "Bug tracking"
                }
            ],
            tag: {
                tagText: "IT & Support",
                tagBackgroundColor: "Projects Darkest Tint 03",
                overridePageCluster: "information_technology"
            },
            cardAsset: "/Generator_featured images/Homepage - 2024/teams- firstfold/IT.png"
        },
        {
            useCases: [
                {
                    useCase: "Recruitment pipeline"
                },
                {
                    useCase: "Engagement survey"
                },
                {
                    useCase: "HR requests"
                },
                {
                    useCase: "Onboarding & offboarding"
                }
            ],
            tag: {
                tagText: "Operations",
                tagBackgroundColor: "Brand Yellow (darker) Tint 02",
                overridePageCluster: "generic"
            }
        }
    ]
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/useNumberOfSlides.js

var getSlideWidth = function(windowWidth) {
    return windowWidth >= 1440 ? 452 : 386;
};
var useNumberOfSlides = function() {
    var ref = (0,react.useState)( true ? window.innerWidth : 0), windowWidth = ref[0], setWindowWidth = ref[1];
    var numberOfSlides = (0,react.useMemo)(function() {
        return windowWidth / getSlideWidth(windowWidth);
    }, [
        windowWidth
    ]);
    (0,react.useEffect)(function() {
        var handleResize = function() {
            return setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return numberOfSlides;
};

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-component.js

function carousel_selectable_product_cards_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_selectable_product_cards_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_selectable_product_cards_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_selectable_product_cards_grid_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_selectable_product_cards_grid_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_selectable_product_cards_grid_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}











var SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
var CarouselSelectableProductCardsGridComponent = function(param) {
    var _cards = param.cards, cards = _cards === void 0 ? [] : _cards, selectableTags = param.selectableTags, autoPlay = param.autoPlay, isInView = param.isInView, _defaultNumberOfCards = param.defaultNumberOfCards, defaultNumberOfCards = _defaultNumberOfCards === void 0 ? 3.5 : _defaultNumberOfCards;
    var slider = (0,react.useRef)(null);
    var ref = (0,react.useState)([]), selectedCardsIndexes = ref[0], setSelectedCardsIndexes = ref[1];
    var buttonContainer = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    var isAutoPlay = (0,react.useMemo)(function() {
        return isInView && !!autoPlay.enable;
    }, [
        isInView,
        autoPlay.enable
    ]);
    var slidesToShow = useNumberOfSlides(cards.length);
    var selectedTags = (0,react.useMemo)(function() {
        return selectedCardsIndexes.map(function(index) {
            return cards[index].tag;
        });
    }, [
        selectedCardsIndexes,
        cards
    ]);
    var selectedProducts = (0,react.useMemo)(function() {
        return selectedCardsIndexes.map(function(index) {
            return cards[index].productType;
        });
    }, [
        selectedCardsIndexes,
        cards
    ]);
    var onTagsClick = function(cardIndex) {
        setSelectedCardsIndexes(function(prevSelectedIndexes) {
            return prevSelectedIndexes.includes(cardIndex) ? prevSelectedIndexes.filter(function(index) {
                return index !== cardIndex;
            }) : (0,_to_consumable_array/* default */.Z)(prevSelectedIndexes).concat([
                cardIndex
            ]);
        });
        setTimeout(function() {
            return setWasClusterSelected(true);
        }, SIGNUP_BUTTON_ANIMATION_START_TIME);
    };
    var onCardClick = function(tag, productType, index) {
        var _buttonContainer_current;
        if (!selectableTags) return;
        onTagsClick(index);
        (_buttonContainer_current = buttonContainer.current) === null || _buttonContainer_current === void 0 ? void 0 : _buttonContainer_current.clickedTag(carousel_selectable_product_cards_grid_component_object_spread({
            tagIndex: index
        }, tag), !selectedTags.includes(tag));
    };
    var itemRenderer = function(card, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(selectable_product_card, carousel_selectable_product_cards_grid_component_object_spread({
            selectableTags: selectableTags,
            onClick: function() {
                return onCardClick(card.tag, card.productType, index);
            }
        }, card));
    };
    var carouselProps = {
        items: cards,
        autoplay: isAutoPlay,
        slidesToShow: slidesToShow || defaultNumberOfCards,
        autoplaySpeed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.autoplaySpeed,
        speed: autoPlay === null || autoPlay === void 0 ? void 0 : autoPlay.speed,
        itemRenderer: itemRenderer,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(prev_carousel_arrow, {
            pause: function() {
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        }),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_carousel_arrow, {
            pause: function() {
                var _slider_current;
                return (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.pause();
            }
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCarouselSelectableProductCardsGridComponent, {
        isAutoPlay: isAutoPlay,
        onMouseLeave: function() {
            var _slider_current;
            return isAutoPlay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.play());
        },
        className: "carousel-selectable-product-cards-grid-component",
        onAnimationEnd: function() {
            return setWasClusterSelected(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, carousel_selectable_product_cards_grid_component_object_spread_props(carousel_selectable_product_cards_grid_component_object_spread({}, CAROUSEL_PROPS, carouselProps), {
                ref: slider
            })),
            selectableTags && /*#__PURE__*/ (0,jsx_runtime.jsx)(clusters_signup, {
                selectedProducts: selectedProducts,
                clusters: selectedTags,
                wasClusterSelected: wasClusterSelected
            })
        ]
    });
};
CarouselSelectableProductCardsGridComponent.defaultProps = default_props;
/* harmony default export */ var carousel_selectable_product_cards_grid_component = (CarouselSelectableProductCardsGridComponent);


/***/ })

}]);